export var CopType = /* @__PURE__ */ ((CopType2) => {
  CopType2["BUILDER"] = "builder";
  CopType2["CUBE_CAMERA"] = "cubeCamera";
  CopType2["VIDEO"] = "video";
  CopType2["WEB_CAM"] = "webCam";
  CopType2["SNAPSHOT"] = "snapshot";
  return CopType2;
})(CopType || {});
export var CopTypeImage = /* @__PURE__ */ ((CopTypeImage2) => {
  CopTypeImage2["IMAGE"] = "image";
  CopTypeImage2["IMAGE_EXR"] = "imageEXR";
  CopTypeImage2["IMAGE_HDR"] = "imageHDR";
  CopTypeImage2["IMAGE_KTX2"] = "imageKTX2";
  return CopTypeImage2;
})(CopTypeImage || {});
